import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';


const spinnerBlades = new Array(8).fill('-');
const SpinnerLoader = ({
   size = 'large',
   bgColor = 'bg-[#585858]',
   style = {},
}) => {
   return (
      <div
         className={ cx({
            'spinner center': true,
            'h-6 w-6': size === 'large',
            'h-5 w-5': size === 'medium',
            'h-4 w-4': size === 'small',
         }) }
      >
         {
            spinnerBlades.map((e, index) => {
               return (
                  <div
                     style={ style }
                     className={ cx({
                        [`spinner-blade ${ bgColor } rounded-full`]: true,
                        'h-[7.64px] w-[2.18px] spinner-blade-large': size === 'large',
                        'h-[6.36px] w-[1.82px] spinner-blade-medium': size === 'medium',
                        'h-[4px] w-[1.45px] spinner-blade-small': size === 'small',
                     }) }
                     key={ index.toString() }></div>
               )
            })
         }
      </div>
   );
};
SpinnerLoader.propTypes = {
   size: PropTypes.oneOf([
      'large', 'medium', 'small',
   ]),
   bgColor: PropTypes.string,
   style: PropTypes.object,
}

export { SpinnerLoader };
